import { useTranslation } from 'react-i18next';

import { Tab } from '../Tab';

import { Form } from './Form';
import { Guide } from './Guide';

export function HubSpot() {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pages.Settings.components.HubSpot',
  });
  return (
    <Tab title={t('title')} description={t('description')}>
      <Guide />
      <Form />
    </Tab>
  );
}
